<div class="pos-panel">
    <div class="pos-panel-header">
        <span class="soc-panel-header">{{'SUPPLIERS.FACILITIES' | translate}}</span>
        <hr class="soc-panel-line" />
    </div>
    <div class="d-flex justify-content-between">
        <span class="soc-h4">{{'SUPPLIERS.SUPPLIERS' | translate}}</span>
    </div>
    <hr class="soc-panel-line" />
        <div class="soc-wrapper-gap-24-column" *ngIf="suppliers && (suppliers.length > 0 || searchTerm != '' || loading)">
            <div class="pos-actions-wrapper">
                <div class="soc-search-wrapper">
                    <div class="p-inputgroup soc-search-field-wrapper">
                        <i class="pi pi-search soc-neutral-text-color"></i>
                        <input type="text" class="soc-search-input-field soc-input-text" [(ngModel)]="searchTerm" (ngModelChange)="search()" placeholder="{{'SEARCH' | translate}}">
                    </div>
                </div>
                <button class="soc-basic-cyan-btn" (click)="newSupplier()"><span
                        class="material-icons-round">store</span>{{'SUPPLIERS.NEW_SUPPLIER' | translate}}</button>
            </div>
            <hr class="soc-panel-line"/>
        </div>
        <div *ngIf="!suppliers || loading" class="soc-loading-wrapper">
            <p-progressSpinner strokeWidth="4"></p-progressSpinner>
        </div> 
        <div *ngIf="suppliers && suppliers.length > 0 && !loading" class="pos-panel-cards-wrapper">
                <ng-container *ngFor="let supplier of suppliers">
                    <div class="soc-card ">
                        <span class="material-icons soc-img-placeholder">store</span>
                        <div class="soc-card-info">
                            <div class="d-flex justify-content-between w-100">
                                <div class="soc-card-title">
                                    <span class="soc-h2">{{supplier.name}}</span>
                                </div>
                                <span class="material-icons neutral-90 "
                                    (click)="$event.stopPropagation(); actionMenu.toggle($event)">more_vert</span>
                                <p-overlayPanel #actionMenu [dismissable]="true" class="d-none">
                                    <div class="soc-action-menu-content">
                                        <div class="soc-action-item" (click)="editSupplier(supplier)">
                                            {{'SUPPLIERS.EDIT_SUPPLIER' | translate}}</div>
                                        <div class="soc-action-item" (click)="deleteSupplier(supplier)">
                                            {{'SUPPLIERS.DELETE_SUPPLIER' | translate}}</div>
                                        <div class="soc-action-item" (click)="addPurchaseOrder(supplier)">
                                            {{'SUPPLIERS.ISSUE_PURCHASE_ORDER' | translate}}</div>
                                    </div>
                                </p-overlayPanel>

                            </div>
                            <div class="d-flex justify-content-between w-100 gap-4">
                                <div class="soc-wrapper-gap-12-column w-50">
                                    <div class="soc-card-subtitle">
                                        <span class="soc-display-lbl w-100">{{'SUPPLIERS.ADDRESS' |translate}}</span>
                                    </div>
                                    <hr class="soc-split-line">
                                    <label _ngcontent-ley-c309="" class="soc-lbl-text-16 soc-neutral-50-text-color"
                                        style="height: 24px;">{{supplier.address}}</label>
                                </div>
                                <div class="soc-wrapper-gap-12-column w-50">
                                    <div class="soc-card-subtitle">
                                        <span class="soc-display-lbl w-100">{{'SUPPLIERS.EMAIL' |translate}}</span>
                                    </div>
                                    <hr class="soc-split-line">
                                    <label _ngcontent-ley-c309="" class="soc-lbl-text-16 soc-neutral-50-text-color"
                                        style="height: 24px;">{{supplier.email}}</label>
                                </div>
                                <div class="soc-wrapper-gap-12-column w-50">
                                    <div class="soc-card-subtitle">
                                        <span
                                            class="soc-display-lbl w-100">{{'SUPPLIERS.PHONE_NUMBER'|translate}}</span>
                                    </div>
                                    <hr class="soc-split-line">
                                    <label _ngcontent-ley-c309="" class="soc-lbl-text-16 soc-neutral-50-text-color"
                                        style="height: 24px;">{{supplier.phone}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
        </div>
        <div *ngIf="suppliers && suppliers.length == 0 && searchTerm == '' && !loading" class="pos-no-entities-wrapper h-100" style="overflow: auto">
            <div class="pos-no-entities-indicator h-100" style="width: 540px;">
                <span class="material-icons pos-no-entities-icon">store</span>
                <span class="soc-h2 text-center">{{'SUPPLIERS.SUPPLIERS' | translate}}</span>
                <span class="soc-p text-center" style="white-space: pre-line;">{{'SUPPLIERS.CREATE_SUPPLIER_TEXT' |
                    translate}}</span>
                <button class="soc-basic-cyan-btn" (click)="newSupplier()">{{'SUPPLIERS.APPOINT_SUPPLIER' |
                    translate}}</button>
            </div>
        </div>    
</div>

<p-confirmDialog class="soc-confirmation-dialog">
</p-confirmDialog>